"use strict";

import angular from "angular";

export class FeedbackModelDialog {
    constructor($stateParams, $mdDialog, locals, $state) {
        this.$stateParams = $stateParams;
        this.$mdDialog = $mdDialog;
        this.locals = locals;
    }

    $onInit() {}
}

angular.module("nucont.shared").controller("FeedbackModelDialog", [
        "$stateParams",
        "$mdDialog",
        "locals",

        FeedbackModelDialog
    ]);
